import { Grid, withStyles, Theme } from '@material-ui/core'
import { ReactNode } from 'react'
import suggestIcon from '../../images/suggest.svg'
import { MuiClasses } from '../../types'
import { allDefined, allValid } from '../../utils/validation/general'

type SuggestProps = {
  classes: MuiClasses
  content?: string
  isModal?: boolean
  hideSuggestIcon?: boolean
  customSuggestTextStyles?: string
  containerStyle?: string
  suggestContainerStyle?: string
  doNextStep?: any
  submit?: boolean
  setIsEmpty?: any
  toValidate?: any
  toCheck?: any
  beforeLogin?: boolean
  renderText: () => ReactNode
  //   startAuth: any
}
const styles = ({ breakpoints }: Theme) => ({
  largeForm: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    justifySelf: 'center',
    [breakpoints.down('sm')]: {
      padding: '10px 0'
    },
    [breakpoints.up('lg')]: {
      display: 'flex'
    }
  },
  suggestContainer: {
    background: '#FBF6EE',
    padding: '25px 40px',
    display: 'flex',
    fontSize: '12px',
    borderRadius: '25px',
    [breakpoints.up('xs')]: {
      padding: '25px'
    },
    '& img': {
      marginRight: '10px'
    }
  },
  suggestIcon: {
    float: 'left' as const,
    padding: '5px'
  },
  suggestText: {
    textAlign: 'left' as const,
    [breakpoints.up('md')]: {
      overflow: 'hidden'
    }
  },
  w13: {
    width: '13%'
  },
  w80: {
    width: '87%'
  },
  wfull: {
    width: '100%'
  },
  cursorPointer: {
    cursor: 'pointer'
  }
})

const StartAuthTrigger = ({
  classes,
  content,
  isModal,
  hideSuggestIcon,
  customSuggestTextStyles,
  suggestContainerStyle,
  containerStyle,
  doNextStep,
  submit,
  setIsEmpty,
  toValidate,
  toCheck,
  beforeLogin,
  renderText
}: //   startAuth
SuggestProps) => {
  const handleClick = (arg: any, fields: any) => {
    if (allDefined(arg) && allValid(fields)) {
      setIsEmpty(false)
      doNextStep(beforeLogin)
    } else setIsEmpty(true)
  }
  return (
    <Grid className={`${classes.largeForm} ${containerStyle}`}>
      <Grid
        container
        onClick={() => {
          handleClick(toValidate, toCheck)
          //   startAuth()
        }}
        className={`${classes.suggestContainer} ${suggestContainerStyle} ${
          doNextStep ? classes.cursorPointer : ''
        }`}
        style={{ flexWrap: 'nowrap' }}
      >
        {!isModal && (
          <Grid item>
            <img src={suggestIcon} />
          </Grid>
        )}
        <Grid container>
          <Grid item className={hideSuggestIcon ? classes.wfull : classes.w80}>
            {renderText()}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
export default withStyles(styles)(StartAuthTrigger)
